import request from '@/utils/request'




//查询多少天内，有哪些会员出现未到店消费
export function queryBdChildNoSingIn(params) {
  return request({
    url: '/admin/BaseData/queryBdChildNoSingIn',
    method: 'get',
    params: params
  })
}

//查询多少天将要过期的会员
export function queryBdVIPWillInvalied(params) {
  return request({
    url: '/admin/BaseData/queryBdVIPWillInvalied',
    method: 'get',
    params: params
  })
}

//查询已经过期过期的会员
export function queryBdVIPInvalied(params) {
  return request({
    url: '/admin/BaseData/queryBdVIPInvalied',
    method: 'get',
    params: params
  })
}

//查询会员生日
export function queryBdChildBirthdayArrived(params) {
  return request({
    url: '/admin/BaseData/queryBdChildBirthdayArrived',
    method: 'get',
    params: params
  })
}

/**
 * 查询一段时间内会员消费次数
 * @param data
 */
export function queryBdConsumeTimesDetail(params) {
  return request({
    url: '/admin/BaseData/queryBdConsumeTimesDetail',
    method: 'get',
    params: params
  })
}
/**
 * 查询一段时间内会员消费次数
 * @param data
 */
export function queryBdConsumeTimesMoneyRate(params) {
  return request({
    url: '/admin/BaseData/queryBdConsumeTimesMoneyRate',
    method: 'get',
    params: params
  })
}

/**
 * 查询一段时间内的满课率
 * @param data
 */
export function queryFullClassRate(params) {
  return request({
    url: '/admin/BaseData/queryFullClassRate',
    method: 'get',
    params: params
  })
}

/**
 * 查询一段时间内的.频率分析
 * @param data
 */
export function queryAnalysisFrequency(params) {
  return request({
    url: '/admin/BaseData/queryAnalysisFrequency',
    method: 'get',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/bd/BaseData.js